import React from 'react';
import DeskType from "../assets/Desk-Type.svg";

const TypingImage = () => {
    return (
        <div>
            <img src={DeskType} alt={TypingImage} style={{width: '350px'}}/>
        </div>
            
    );
};

export default TypingImage;